import { HttpErrorResponse } from '@angular/common/http';

import { CorrelationId, createEntityCollectionStore, ngrxEvent } from '@recruitee/ngrx';

import { ReactionNotePayload, ReactionResponse } from './reactions-http-client';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReactionResponse>()(
  'reactions',
  {
    customActions: () => ({
      addNoteReaction: ngrxEvent<{ data: ReactionNotePayload } & CorrelationId>(),
      addNoteReactionSuccess: ngrxEvent<{ data: ReactionResponse } & CorrelationId>(),
      addNoteReactionFailed: ngrxEvent<
        { error: HttpErrorResponse; data: ReactionNotePayload } & CorrelationId
      >(),

      removeNoteReaction: ngrxEvent<{ data: ReactionNotePayload } & CorrelationId>(),
      removeNoteReactionSuccess: ngrxEvent<{ data: ReactionResponse } & CorrelationId>(),
      removeNoteReactionFailed: ngrxEvent<
        { error: HttpErrorResponse; data: ReactionNotePayload } & CorrelationId
      >(),
    }),
  },
);

const ReactionActions = <
  Pick<
    typeof actions,
    | 'addNoteReaction'
    | 'addNoteReactionSuccess'
    | 'addNoteReactionFailed'
    | 'removeNoteReaction'
    | 'removeNoteReactionSuccess'
    | 'removeNoteReactionFailed'
  >
>actions;

export {
  ReactionActions,
  selectors as ReactionSelectors,
  reducer as ReactionReducer,
  namespace as ReactionNamespace,
};
